/**
 * Marketing attribution helper — captures UTM params + Google Ads gclid
 * from the landing URL and persists them across the session so any
 * subsequent form submission can attribute the lead back to the ad click.
 */

const STORAGE_KEY = "mr_attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const collected = {};
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) collected[f] = v.slice(0, 200);
    });
    if (Object.keys(collected).length === 0) return;
    // Don't overwrite an earlier capture on this device unless gclid is present (refresh signal)
    const existing = getAttribution();
    if (existing && !collected.gclid) return;
    collected.landed_at = new Date().toISOString();
    collected.landing_path = window.location.pathname + window.location.search;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(collected));
  } catch (_) {
    /* noop */
  }
}

export function getAttribution() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

/**
 * Fire a Google Ads conversion event. gtag is loaded in index.html.
 * Pass the conversion ID + label as `AW-XXXXXXX/abcDEFG` (set in index.html).
 */
export function trackConversion(conversionRef, value, currency = "CAD") {
  if (typeof window === "undefined" || !window.gtag || !conversionRef) return;
  try {
    window.gtag("event", "conversion", {
      send_to: conversionRef,
      value: value || 1.0,
      currency,
    });
  } catch (_) {
    /* noop */
  }
}

/**
 * Phone-call conversion (for tel: links).
 */
export function trackPhoneCall(conversionRef) {
  if (typeof window === "undefined" || !window.gtag) return true;
  try {
    window.gtag("event", "conversion", { send_to: conversionRef });
  } catch (_) {
    /* noop */
  }
  return true;
}

// Conversion references — replace with your real Google Ads values when ready.
// Format: 'AW-XXXXXXXXX/AbCdEfGhIjKlMnOpQr'
export const ADS_CONFIG = {
  // Set from env so you can override without code changes
  conversionId: process.env.REACT_APP_GOOGLE_ADS_ID || "AW-CONVERSION_ID",
  quoteLabel: process.env.REACT_APP_ADS_QUOTE_LABEL || "QUOTE_LABEL",
  contactLabel: process.env.REACT_APP_ADS_CONTACT_LABEL || "CONTACT_LABEL",
  callLabel: process.env.REACT_APP_ADS_CALL_LABEL || "CALL_LABEL",
};

export function quoteConversionRef() {
  return `${ADS_CONFIG.conversionId}/${ADS_CONFIG.quoteLabel}`;
}
export function contactConversionRef() {
  return `${ADS_CONFIG.conversionId}/${ADS_CONFIG.contactLabel}`;
}
export function callConversionRef() {
  return `${ADS_CONFIG.conversionId}/${ADS_CONFIG.callLabel}`;
}
